module.exports = __webpack_public_path__ + "img/htsslogow.d2be6657.png";